//
// forms/utm-saver.js - save passed utm parameters into localstorage
//                    - should be run on page load
//

import {data_store} from './data-store';

const utm_parameter_names = [
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_content',
  'utm_campaign',
  'utm_device',
  'utm_date',
  'utm_referral',
];


// Get URL query parameters
// ------------------------------------------------------

function get_url_query_params() {
  // TODO: use url.spec.whatwg.org/#urlsearchparams instead:
  //       - will require polyfill & es6 transpilation for iterator-based interface
  //
  //    var params = [...(new URLSearchParams(window.location.search))];
  //    return params.reduce((accum, item) => Object.assign(accum, { [item[0]] : item[1] }), { });

  const query = location.search.substr(1);
  if (query.length == 0) {
    return [ ];
  }
  return query.split('&').reduce(function(ret, part) {
    const [name, value] = part.split('=');
    ret[name] = decodeURIComponent(value);
    return ret;
  }, { });
}


// save_utms()
// ------------------------------------------------------
// - Save current query string UTMs into sessionStorage
// - Also save as fv_* if not found

function save_utms() {
  var store = data_store();
  if (store === null) {
    return;
  }

  var query_params = get_url_query_params();
  var d = new Date(Date.now() - 5*3600*1000);
  query_params.utm_date = `${d.getUTCDate()}_${d.getUTCMonth()+1}_${d.getUTCFullYear()}`;

  utm_parameter_names.forEach(function(pname) {
    var fv_item_name = 'fv_' + pname;
    var value__query_string = (query_params.hasOwnProperty(pname) ? query_params[pname] : '_');
    var value__fv_stored = store.get_for_session(fv_item_name);

    // Save the current utm to session storage
    if (value__query_string !== '_') {
      store.set_for_session(pname, value__query_string);
    }

    // Save the current fv_ if is not in the store
    if (value__fv_stored === null) {
      store.set_for_session(fv_item_name, value__query_string);
    }
  });
}


save_utms();

